import { useIntl } from 'react-intl';
import { useMedia } from 'react-use';
import { useTheme } from 'styled-components';

import { LANGUAGES, media } from '@savgroup-front-common/constants';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { LanguageChooser } from '@savgroup-front-common/core/molecules/LanguageChooser';
import { ReversioIcon } from '@savgroup-front-common/core/protons/icons';

import messages from './messages';
import {
  $BackgroundCol,
  $ImgDescription,
  $ImgTitle,
  $LanguageChooser,
  $OnboardingEntry,
  $OnboardingEntryFormContainer,
} from './OnboardingEntry.styles';
import OnboardingForm from './OnboardingForm/OnboardingForm';

const OnboardingEntry = ({
  handleUserEmail,
}: {
  handleUserEmail: (userEmail: string) => void;
}) => {
  const theme = useTheme();
  const isMobileView = useMedia(media.maxWidth.sm);
  const intl = useIntl();
  const { locale } = intl;

  return (
    <$OnboardingEntry>
      {!isMobileView && (
        <$BackgroundCol xs={6}>
          <a href="https://www.revers.io">
            <ReversioIcon color={theme.colors.white} />
          </a>
          <$ImgTitle>
            <SafeFormattedMessageWithoutSpread message={messages.imgTitle} />
          </$ImgTitle>
          <$ImgDescription>
            <SafeFormattedMessageWithoutSpread
              message={messages.imgDescription}
            />
          </$ImgDescription>
          {locale === LANGUAGES.EN && (
            <img src={'/images/OnboardingImageEN.svg'} alt="" />
          )}
          {locale === LANGUAGES.FR && (
            <img src={'/images/OnboardingImageFR.svg'} alt="" />
          )}
        </$BackgroundCol>
      )}
      <$OnboardingEntryFormContainer xs={isMobileView ? 12 : 6}>
        <$LanguageChooser>
          <LanguageChooser acceptedLanguages={[LANGUAGES.FR, LANGUAGES.EN]} />
        </$LanguageChooser>

        <OnboardingForm handleUserEmail={handleUserEmail} />
      </$OnboardingEntryFormContainer>
    </$OnboardingEntry>
  );
};

OnboardingEntry.displayName = 'OnboardingEntry';

export default OnboardingEntry;
